import { useContext } from 'react';

import { NotificationsContext } from 'app/contexts/notifications-context';

const useNotifications = () => {
  return useContext(NotificationsContext);
};

export default useNotifications;
